import { useState } from "react";
import api, { fmtErr } from "../lib/api";
import { PublicLayout, SectionHeading } from "../components/PublicLayout";
import { useCaptcha, CaptchaField } from "../components/Captcha";

const inputCls = "mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 outline-none";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const cap = useCaptcha();
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/contact", { ...form, ...cap.payload });
      setDone(data.message);
    } catch (err) { setError(fmtErr(err)); cap.refresh(); }
  };

  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="contact-page">
        <SectionHeading eyebrow="Contact" title="Talk to a real publisher"
          sub="Questions about plans, your manuscript, or an existing project? Send us a note." />
        {done ? (
          <div data-testid="contact-success" className="text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-2xl p-8 text-center font-medium">{done}</div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm space-y-4">
            {error && <div data-testid="contact-error" className="text-red-700 bg-red-50 border border-red-200 rounded-md p-3 text-sm">{error}</div>}
            <div className="grid sm:grid-cols-2 gap-4">
              <div><label className="text-sm font-medium text-neutral-700">Your name</label>
                <input data-testid="contact-name-input" required value={form.name} onChange={set("name")} className={inputCls} /></div>
              <div><label className="text-sm font-medium text-neutral-700">Email</label>
                <input data-testid="contact-email-input" type="email" required value={form.email} onChange={set("email")} className={inputCls} /></div>
            </div>
            <div><label className="text-sm font-medium text-neutral-700">Message</label>
              <textarea data-testid="contact-message-input" rows={5} required value={form.message} onChange={set("message")} className={inputCls} /></div>
            <CaptchaField {...cap} testId="contact-captcha" />
            <button data-testid="contact-submit-button" className="px-6 py-2.5 rounded-full text-white bg-neutral-900 hover:bg-neutral-700 text-sm font-medium transition-colors">Send message</button>
          </form>
        )}
      </section>
    </PublicLayout>
  );
}
